'use client';
import { LazyMotion, m } from 'framer-motion';
import { FC } from 'react';
import { Link } from '@/components/ui';
import { useTranslation } from '@/providers/app-provider/app-provider';
import { CategoryTree } from '@/types/category/category-get-tree';
import loadFramerMotionFeatures from '@/utils/framer-motion-features';
import { selectCategoryImage } from '@/utils/select-category-image';

type Props = {
  categories: CategoryTree[];
};

const CategoryPageContent: FC<Props> = ({ categories }) => {
  const { t } = useTranslation();

  return (
    <div className="py-8">
      <h1 className="mb-9 text-center text-2xl font-semibold text-gray-800 sm:text-2xl lg:text-3xl">
        {t?.categories.title}
      </h1>
      {/* `LazyMotion` + `m.*` defers framer-motion's heavy projection layer
          until a child actually mounts. The async features loader (see
          `@/utils/framer-motion-features`) lets webpack split the animation
          features into their own chunk, loaded after first paint. */}
      <LazyMotion features={loadFramerMotionFeatures} strict>
        <div className="grid auto-rows-[200px] grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {categories.map(item => {
            return (
              <Link key={item.id} href={`/products/${item.meta.url}`} noStyle className="contents">
                <m.div
                  className="relative flex cursor-pointer items-center justify-center rounded-2xl bg-cover bg-center p-4"
                  style={{
                    backgroundImage: `url(${selectCategoryImage(item.meta.thumbnail)})`,
                    backgroundSize: 'cover',
                  }}
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <div className="bg-opacity-50 absolute inset-0 rounded-2xl bg-black"></div>

                  <span className="z-10 w-full overflow-hidden text-center font-semibold text-ellipsis text-white uppercase sm:text-base lg:text-2xl">
                    {item.name}
                  </span>
                </m.div>
              </Link>
            );
          })}
        </div>
      </LazyMotion>
    </div>
  );
};

export default CategoryPageContent;
